module.exports = __webpack_public_path__ + "img/wave.fb63f552.png";